// @flow
import React from 'react';
// Styles
import './BlackFridayProductList.css';
// Components
import Slider from 'react-slick';
import { AddToCartButton } from '../../current-order';
import { ProductPrice, ProgressiveImageLoader } from '../../common';
import { SlickSliderArrow } from '../../common';
import CookingRecommedationBox from '../../current-order/components/CookingRecommedationBox';
// Types
import { Product } from '../../products';
// Analytics
import { logLandingSliderSlid } from '../../common/analytics';
// Assest
import arrowIcon from '../images/arrow-icon.svg';
//Helpers
import { scaleConverter } from '../../common';

type Props = {
  sliderProductsVariants: Product[],
  currentLanding: string,
};

const BlackFridayProductList = ({
  sliderProductsVariants = [],
  productsVariants = [],
  currentLanding,
}: Props) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    vertical: false,
    lazyLoad: true,
    arrows: true,
    nextArrow: (
      <SlickSliderArrow
        containerStyle="landing-product-list-arrow-container"
        direction="right"
        iconLeftStyle="fa fa-caret"
        iconRightStyle="fa-4x"
        disabledClassName="landing-product-list-scroller-arrow-disabled"
        arrowScrollerClassName="landing-product-list-scroller-arrow  scroller-arrow"
      />
    ),
    prevArrow: (
      <SlickSliderArrow
        containerStyle="landing-product-list-arrow-container"
        direction="left"
        iconLeftStyle="fa fa-caret"
        iconRightStyle="fa-4x"
        disabledClassName="landing-product-list-scroller-arrow-disabled"
        arrowScrollerClassName="landing-product-list-scroller-arrow  scroller-arrow"
      />
    ),
  };

  const sliderRef = React.createRef();

  const goToNextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const calculateProductDiscount = (listPrice, price) => {
    if (listPrice > price) {
      const discountPercentage = ((listPrice - price) / listPrice) * 100;
      return Math.round(discountPercentage);
    }
    return null;
  };

  const onSlideChange = index => {
    logLandingSliderSlid(currentLanding);
  };

  if (sliderProductsVariants.length <= 0) {
    return null;
  }

  return (
    <div className="black-friday-product-list-main-container">
      <div className="black-friday-product-list-content">
        {sliderProductsVariants.length > 0 && (
          <Slider {...settings} afterChange={onSlideChange} ref={sliderRef}>
            {sliderProductsVariants.map((sliderProduct, index) => {
              const price = scaleConverter(sliderProduct.price);
              const listPrice = scaleConverter(sliderProduct.listPrice);

              const productOnPromotion = listPrice > price;
              const productDiscount = calculateProductDiscount(
                listPrice,
                price,
              );
              return (
                <div
                  className="black-friday-product-list-item-content-container"
                  key={index}
                >
                  <div className="black-friday-product-list-individual-product-container">
                    <div className="black-friday-product-list-image-container">
                      {productOnPromotion && productDiscount >= 5 && (
                        <div className="black-friday-product-discout-square">
                          <p>{Math.round(productDiscount)}%</p>
                          <span>OFF</span>
                        </div>
                      )}
                      <ProgressiveImageLoader
                        selectedImage={sliderProduct.images[0]}
                        imageToShow={'large'}
                      />
                    </div>
                    <div className="black-friday-product-list-product-details">
                      <div className="black-friday-product-list-product-text">
                        <p className="black-friday-product-list-product-manufacturer">
                          {sliderProduct.manufacturer}
                        </p>
                        <h4 className="">{sliderProduct.name}</h4>
                      </div>
                      <div className="black-friday-product-list-product-lower-content">
                        <div className="black-friday-product-list-icons-container">
                          <h1>Ideal para</h1>
                          <div className="black-friday-product-list-icons-content">
                            <CookingRecommedationBox
                              cookingMethods={
                                sliderProduct.cookingRecommendations
                              }
                            />
                          </div>
                        </div>
                        <div className="black-friday-product-list-buy-container">
                          <ProductPrice
                            productListPrice={sliderProduct.listPrice}
                            productPrice={sliderProduct.price}
                            productUnit={sliderProduct.unitForQuantity}
                          />
                          <AddToCartButton
                            showNotifyMeButton={false}
                            productId={sliderProduct.id}
                            slug={sliderProduct.slug}
                            unitForQuantity={sliderProduct.unitForQuantity}
                            defaultQuantity={sliderProduct.defaultQuantity}
                            incrementQuantity={sliderProduct.incrementQuantity}
                            inStock={sliderProduct.inStock}
                            discontinued={sliderProduct.discontinued}
                            shouldNotifyUser={sliderProduct.shouldNotifyUser}
                            analyticsEventType={'landingPage'}
                          />
                          <img
                            className="black-friday-product-list-arrow-icon"
                            src={arrowIcon}
                            alt="Icone de seta"
                            onClick={goToNextSlide}
                          ></img>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default BlackFridayProductList;
